<template>
  <div class="h-dvh overflow-y-auto text-text-primary">
    <!-- Scorre un solo contenitore, mai la finestra (come layouts/default.vue); lo sfondo lo disegna AuthLayout. -->
    <slot />
  </div>
</template>
